<template src="@/templates/app.html"></template>

<script>
import Symulator from './components/Symulator.vue'

export default {
  name: 'App',
  data(){
    return {
      size: '',
      wndWidth: 0,
    };
  },
  components: {
    Symulator
  },
  mounted() {
    const self = this;
    window.addEventListener('resize',function(){
      self.resize();
    });
    this.resize();
  },
  methods: {
    resize(){
      this.size = 'esolano';
      this.wndWidth = window.innerWidth
      console.log(this.$el.clientWidth);
      if(this.$el.clientWidth > 720){
        this.size += ' md'
      }
      if(this.$el.clientWidth > 1140){
        this.size += ' xl'
      }
    },
  }
}
</script>

<style lang="scss">
@import './main.scss';
</style>
